import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import FontAwesome CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

// Import Bootstrap and custom styles
import './styles/main.scss';

// Import Bootstrap JavaScript for interactive components (dropdowns, modals, etc.)
import 'bootstrap';

// Initialize HTTP interceptors
import { setupInterceptors } from '@/services/http';
setupInterceptors();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
